import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/site';
export function Testimonials() {
  return <section id="reviews" className="bg-[#EAF7FF] py-20 lg:py-28" data-id="element-196" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-197" data-mp="3fyvy6aic1db3">
        <div className="max-w-2xl" data-id="element-198" data-mp="3fxb4so7r80et">
          <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-[#0B1B2B]/50" data-id="element-199" data-mp="3b1cl3dxdf6kq">
            Reviews
          </p>
          <h2 className="mt-3 text-4xl font-black leading-[1.02] tracking-tight text-[#0B1B2B] sm:text-5xl" data-id="element-200" data-mp="370kb2igocxne">
            People notice. That's kind of the point.
          </h2>
        </div>

        <ul className="mt-12 grid gap-6 lg:grid-cols-3" data-id="element-201" data-mp="2x1l18wk6avyt">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col rounded-[1.75rem] border-4 border-[#0B1B2B] bg-[#FFFDF6] p-8 shadow-[6px_6px_0_0_#0B1B2B]" data-id="element-202" data-mp="2s39puhe8cdeh">
              <Quote className="h-8 w-8 text-[#FFD84D]" aria-hidden="true" data-id="element-203" data-mp="qava9oz5rl18" />
              <p className="mt-4 flex-1 text-lg font-semibold leading-relaxed text-[#0B1B2B]" data-id="element-204" data-mp="h5oox8u9426d">
                “{testimonial.quote}”
              </p>
              <div className="mt-6 flex items-center gap-1" aria-label="5 out of 5 stars" data-id="element-205" data-mp="m2om0u94hulc">
                {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="h-4 w-4 fill-[#FFD84D] text-[#0B1B2B]" aria-hidden="true" data-id="element-206" data-mp="c7wn9n3t11oz" data-mpi={i} />)}
              </div>
              <p className="mt-3 text-sm font-extrabold text-[#0B1B2B]" data-id="element-207" data-mp="14uzl0d0np8e6">
                {testimonial.name}
                <span className="ml-2 font-bold text-[#0B1B2B]/50" data-id="element-208" data-mp="q6curg9hqw86">{testimonial.role}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}